import React from 'react';

import CoreContainer from 'core/components/CoreContainer';
import { PanelSetupRequired } from 'core/components/editor/EditToggle';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { nDef } from 'core/util/TypeUtils';
import ContainerConfig from './ContainerConfig';
import ContainerView from "./view/Container.view";
import PanelLayout from './PanelLayout';

/**
 * @overview: A wrapper for n child {@link @Panel}s. For displaying children in
 * a page or layout see {@link LayoutPanel} and {@link PagePanel} respectively.
 *
 * @author: jesposito
 */

@Panel({id: "container", configClass: ContainerConfig})
export default class Container extends React.PureComponent<IPanelProps<ContainerConfig>, any> {

	public render() {
		const { config } = this.props;

		if(nDef(config) || nDef(config.children) || config.children.length <= 0) {
			return (
				<PanelSetupRequired description="Add some panels to get started" />
			);
		}

		if(config.layoutEnabled && config.layout) {
			const layout = <PanelLayout layoutData={config.layout} panelsAvailable={config.children} />;

			return (
				(config.noWrapper && layout) || (
					<ContainerView viewKey="container-wrapper">
						{layout}
					</ContainerView>
				)
			);
		}

		const container = <CoreContainer children={config.children} />;

		if(config.noWrapper) {
			return container;
		}

		/* wrap in div instead of styled component for react dnd to work correctly */
		return (
			<ContainerView viewKey="container-wrapper">
				{container}
			</ContainerView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/container/Container.panel.tsx